import React, { useEffect } from 'react';
import { initializeBlipDS } from '@/core/utils/webComponent';
import Wrapper from '@/core/components/Wrapper/Wrapper';
import Routes from './routes/Routes';
import { Loader } from '@/core/components/Loader/Loader';
import { useAuth } from '@/core/hooks/useAuth';

export const App: React.FC = () => {
  const { hasInitialData } = useAuth();

  useEffect(() => {
    initializeBlipDS();
  }, []);

  if (!hasInitialData) {
    return <Loader />;
  }

  return (
    <Wrapper>
      <Routes ownerIdentity="defaultOwner" />
    </Wrapper>
  );
};
